import { rem } from "@certn/cascadia";
import { Card, PrimaryButton, Text } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useUser } from "../hooks/api/useUser";
import { AuthHeader } from "../pages/auth/AuthHeading";

export function InaccessibleApplication() {
  const { t } = useTranslation();
  const { user } = useUser();
  const navigate = useNavigate();

  return (
    <Card border="none" type="large">
      <AuthHeader
        title={t("This link has expired")}
        subtitle={t("Looks like this URL is no longer valid.")}
      />
      <div
        style={{
          marginTop: rem("space-6"),
          marginBottom: rem("space-6"),
        }}
      >
        <PrimaryButton fullWidth size="large" onPress={() => navigate("/")}>
          {t("Return to Dashboard")}
        </PrimaryButton>
      </div>
      <div style={{ textAlign: "center" }}>
        <Text>
          {t("You are currently signed in as")} {user?.email}.
        </Text>
      </div>
    </Card>
  );
}
